import { render } from "./GlobalNaviKanriComponent.vue?vue&type=template&id=33ac3c4e&ts=true"
import script from "./GlobalNaviKanriComponent.vue?vue&type=script&lang=ts"
export * from "./GlobalNaviKanriComponent.vue?vue&type=script&lang=ts"

import "./GlobalNaviKanriComponent.vue?vue&type=style&index=0&id=33ac3c4e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__